import { render } from "./HermesConfirmModal.vue?vue&type=template&id=13328314&scoped=true"
import script from "./HermesConfirmModal.vue?vue&type=script&lang=js"
export * from "./HermesConfirmModal.vue?vue&type=script&lang=js"

import "./HermesConfirmModal.vue?vue&type=style&index=0&id=13328314&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13328314"]])

export default __exports__